import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { rem } from '~/common/utils/style';

interface PageWrapperProps {
  children: ReactNode;
  paddingBottom?: number;
  paddingBottomMobile?: number;
  paddingTop?: number;
  paddingTopMobile?: number;
  paddingX?: number;
  paddingXMobile?: number;
  maxWidth?: string;
}

const PageWrapper: FC<PageWrapperProps> = ({
  children,
  paddingBottom,
  paddingBottomMobile,
  paddingTop,
  paddingTopMobile,
  paddingX,
  paddingXMobile,
  maxWidth,
}) => {
  return (
    <Wrapper
      paddingBottom={paddingBottom}
      paddingBottomMobile={paddingBottomMobile}
      paddingTop={paddingTop}
      paddingTopMobile={paddingTopMobile}
      paddingX={paddingX}
      paddingXMobile={paddingXMobile}
      maxWidth={maxWidth}
    >
      {children}
    </Wrapper>
  );
};

export default PageWrapper;

export const Wrapper = styled.div<{
  paddingBottom?: number;
  paddingBottomMobile?: number;
  paddingTop?: number;
  paddingTopMobile?: number;
  paddingX?: number;
  paddingXMobile?: number;
  maxWidth?: string;
}>`
  margin: 0 auto;
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || '90rem'};
  padding-bottom: ${({ paddingBottom }) => rem(paddingBottom, 7.5)};
  padding-top: ${({ paddingTop }) => rem(paddingTop, 7.5)};
  padding-left: ${({ paddingX }) => rem(paddingX, 0)};
  padding-right: ${({ paddingX }) => rem(paddingX, 0)};

  @media ${({ theme }) => theme.breakpoints.lg} {
    padding-bottom: ${({ paddingBottom }) => rem(paddingBottom, 2)};
    padding-top: ${({ paddingTop }) => rem(paddingTop, 2)};
    padding-left: ${({ paddingX }) => rem(paddingX, 2)};
    padding-right: ${({ paddingX }) => rem(paddingX, 2)};
  }

  @media ${({ theme }) => theme.breakpoints.md} {
    padding-bottom: ${({ paddingBottom }) => rem(paddingBottom, 5.5)};
    padding-top: ${({ paddingTop }) => rem(paddingTop, 5.5)};
    padding-left: ${({ paddingX }) => rem(paddingX, 1.5)};
    padding-right: ${({ paddingX }) => rem(paddingX, 1.5)};
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    padding-bottom: ${({ paddingBottomMobile }) =>
      rem(paddingBottomMobile, 4.25)};
    padding-top: ${({ paddingTopMobile }) => rem(paddingTopMobile, 4.25)};
    padding-left: ${({ paddingXMobile }) => rem(paddingXMobile, 1)};
    padding-right: ${({ paddingXMobile }) => rem(paddingXMobile, 1)};
  }
`;
